import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule as UrsaSharedModule } from '../../shared/shared.module';
import { CategorizationContainerComponent } from '../categorization/views/categorization-container/categorization-container.component';
import { GenAiContainerComponent } from '../gen-ai/views/gen-ai-container/gen-ai-container.component';
import { H3mlModule } from '../h3ml/h3ml.module';
import { CompareAnswersComponent } from './compare-answers/compare-answers.component';
import { ReadOnlyWorkspaceNavbarComponent } from './navbar/read-only-workspace-navbar/read-only-workspace-navbar.component';
import { ReadOnlyWorkspaceHostComponent } from './read-only-workspace-host.component';
import { ReadOnlyWorkspaceComponent } from './read-only-workspace.component';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    GenAiContainerComponent,
    CategorizationContainerComponent,
    H3mlModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    OverlayModule,
    UrsaSharedModule,
  ],
  declarations: [
    CompareAnswersComponent,
    ReadOnlyWorkspaceComponent,
    ReadOnlyWorkspaceNavbarComponent,
    ReadOnlyWorkspaceHostComponent,
  ],
})
export class ReadOnlyWorkspaceModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    customElements.define(
      'ursa-read-only-workspace',
      createCustomElement(ReadOnlyWorkspaceHostComponent, {
        injector: this.injector,
      }),
    );
  }
}
